import React from 'react';
import PropTypes from 'prop-types';

import { registerLocale } from 'react-datepicker';
import ptBr from 'date-fns/locale/pt-BR';

import Label from '../Label';

import * as S from './styles';
import './modifiers.css';

registerLocale('pt-br', ptBr);

const DateField = ({
  selectedValue,
  handleChange,
  placeholderText,
  onlyMonth,
  width,
  startDate,
  name,
  disabled,
  className,
  isClearable,
  labelText,
}) => (
  <S.Container>
    <Label text={labelText} hasMargin htmlFor={name} />
    <S.DateField
      name={name}
      id={name}
      locale="pt-br"
      fieldWidth={width}
      selected={selectedValue}
      onChange={handleChange}
      timeCaption="time"
      showMonthYearPicker={onlyMonth}
      startDate={startDate}
      dateFormat={onlyMonth ? 'MM/yyyy' : 'dd/MM/yyyy'}
      placeholderText={placeholderText}
      disabled={disabled}
      className={className}
      isClearable={isClearable}
    />
  </S.Container>
);

export default DateField;

DateField.defaultProps = {
  disabled: false,
  handleChange: () => {},
  onlyMonth: true,
  width: 100,
  placeholderText: 'Selecione',
  startDate: new Date().getTime(),
  name: '',
  className: '',
  isClearable: false,
  labelText: '',
};

DateField.propTypes = {
  isClearable: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  selectedValue: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.number,
  ]).isRequired,
  handleChange: PropTypes.func,
  placeholderText: PropTypes.string,
  onlyMonth: PropTypes.bool,
  width: PropTypes.number,
  startDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  labelText: PropTypes.string,
};
